<template>
  <div id="page-dev-common-alert">
    <v-container>
      <v-row class="py-8" align="center" justify="center">
        <v-col cols="12" class="text-center">
          <span class="display-1 font-weight-light">Common Alert</span>
          <br/>
          <span class="subtitle-1 font-weight-light deepOrange--text">Custom Common Alert Examples</span>
        </v-col>

        <!-- EXAMPLE -1 -->
        <v-col cols="12">
          <c-card title="Default Dialog">
            <v-row justify="space-around">
              <c-btn color="blue" @click="onInfoDialogOpen">Info</c-btn>
              <c-btn color="red" @click="onErrDialogOpen">Error</c-btn>
            </v-row>
          </c-card>
        </v-col>

        <!-- EXAMPLE -1-2 -->
        <v-col cols="12">
          <c-card title="Default Dialog - add callBack">
            <v-row justify="space-around">
              <c-btn color="blue" @click="onInfoDialogWithCallbackOpen">Info</c-btn>
              <c-btn color="red" @click="onErrDialogWithCallbackOpen">Error</c-btn>
            </v-row>
          </c-card>
        </v-col>

        <!-- EXAMPLE -2 -->
        <v-col cols="12">
          <c-card title="Persistent Dialog">
            <v-row justify="space-around">
              <c-btn color="blue" @click="onInfoDialogOpen2">Persistent Dialog</c-btn>
            </v-row>
          </c-card>
        </v-col>

        <!-- EXAMPLE -3 -->
        <v-col cols="12">
          <c-card title="Set Timeout Dialog">
            <v-row justify="space-around">
              <c-btn color="blue" @click="onInfoDialogOpen3">Timout Dialog</c-btn>
            </v-row>
          </c-card>
        </v-col>

        <!-- EXAMPLE -4 -->
        <v-col cols="12">
          <c-card title="Confirm Dialog">
            <v-row justify="space-around">
              <c-btn color="blue" @click="onConfirmDialogOpen">Confirm Dialog1</c-btn>
            </v-row>
          </c-card>
        </v-col>

        <!-- EXAMPLE -4 -->
        <v-col cols="12">
          <c-card title="Confirm Dialog">
            <v-row justify="space-around">
              <c-btn color="blue" @click="onConfirmDialogOpen2">Confirm Dialog2</c-btn>
            </v-row>
          </c-card>
        </v-col>

      </v-row>
    </v-container>
  </div>
</template>

<script>
  export default {
    data: () => ({}),
    methods: {
      onInfoDialogOpen() {
        this.$store.commit('alert', {open: true, msg: "info message"});
      },

      onInfoDialogWithCallbackOpen() {
        this.$store.commit('alert', {
          open: true, msg: "info message",
          persistent: true,
          callBack: () => {
            this.confirmDialogCallback();
          }
        });
      },

      onErrDialogOpen() {
        this.$store.commit('alert', {open: true, err: true, msg: "err message"});

      },

      onErrDialogWithCallbackOpen() {
        this.$store.commit('alert', {
          open: true, err: true, msg: "err message",
          persistent: true,
          callBack: () => {
            this.confirmDialogCallback();
          }
        });
      },

      onInfoDialogOpen2() {
        this.$store.commit('alert', {open: true, persistent: true, msg: "info message"});
      },

      onInfoDialogOpen3() {
        this.$store.commit('alert', {open: true, timeout: 3000, msg: "info message"});
      },

      onConfirmDialogOpen() {
        this.$store.commit('alert',
          {
            open: true, persistent: true, msg: "confirm message",
            confirm: true, callBack: () => {
              this.confirmDialogCallback();
            }
          });
      },

      onConfirmDialogOpen2() {
        this.$store.commit('alert',
          {
            open: true, persistent: true, msg: "confirm message",
            confirmBoth: true,
            callBack: () => {
              this.confirmDialogCallback();
            },
            callBackCancel:() => {
              this.confirmDialogCancelCallback();
            }
          });
      },
      confirmDialogCallback() {
        alert('confirm!');
      },

      confirmDialogCancelCallback() {
        alert('cancel!');
      }

    }
  }
</script>
